import { MethodEnum } from '@enum/method.enum';
import { isString } from '@util/data/is-exist';

export const jsTemplate = (
  link: string,
  headers: Record<string, string> = {},
  body: Record<string, string> = {},
  method: MethodEnum = MethodEnum.GET,
) => `const headers = new Headers();
${Object.entries(headers)
  .filter(([, value]) => isString(value))
  .map(([key, value]) => `headers.append("${key}", "${value}");`)
  .join('\n')}

const body = ${JSON.stringify(body, null, '\t')};

const requestOptions = {
  method: '${method}',
  headers: headers,
  body: body,
  redirect: 'follow'
};

fetch("${link}", requestOptions)
  .then(response => response.json())
  .then(result => console.log(result))
  .catch(error => console.log('error', error));`;
